export default "__VITE_ASSET__gGrRULFf__"